import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleDisconnectedModalStyled = styled('div', {
  width: '571px',
  height: '236px',
  padding: '32px',
})

export const GoogleDisconnectedFirstParagraph = styled('div', {
  fontSize: '$lg',
})

export const GoogleDisconnectedSecondParagraph = styled('div', {
  fontSize: '$lg',
  marginTop: '$10',
})
